<template>
  <div class="form-select-nationality">
    <el-select v-if="!readonly" v-model="innerValue" filterable placeholder="请选择">
      <el-option
        v-for="item in nationalityList"
        :key="item.iso_code3"
        :label="item.cn_name"
        :value="item.iso_code3">
      </el-option>
    </el-select>
    <span class="read-only-box" v-else>{{currentNationalityText}}</span>
  </div>
</template>

<script>
import constsService from '@/services/consts-service';

export default {
  components: {},
  props: {
    value: {
      type: String,
    },
    readonly: Boolean,
  },
  data() {
    return {
      nationalityList: [],
    };
  },
  computed: {
    innerValue: {
      get() {
        return this.value;
      },
      set(val) {
        this.$emit('input', val);
      },
    },
    currentNationalityText() {
      const item = this.nationalityList.find(item => item.iso_code3 === this.innerValue);
      return item && item.cn_name;
    },
  },
  created() {
    this.getNationalityList();
  },
  methods: {
    getNationalityList() {
      constsService.getNationalityList().then((data) => {
        this.nationalityList = data;
      });
    },
  },
};
</script>

<style lang="less" scoped>

</style>



// WEBPACK FOOTER //
// src/components/upload/ocr-info/components/form-select-nationality.vue